import { WelcomePage } from "../pages/welcome";


export const commonProtectedRoutes = [
    {
        label: 'Início',
        path: '/inicio',
        element: <WelcomePage />
    }
];